export const types = {
    FETCH_REQUEST: 'STATISTICS_LIST_HISTORY_FETCH_REQUEST',
    FETCH_SUCCESS: 'STATISTICS_LIST_HISTORY_FETCH_SUCCESS',
    FETCH_FAILURE: 'STATISTICS_LIST_HISTORY__FETCH_FAILURE',
}